import {BaseService} from "./base";
import {getSexFromIdCardFilter} from "../filters";
import {isEmpty, timeFormat} from "../utils";

class ReferralService extends BaseService {
  constructor() {
    super();
  }


  /**
   * 医助医转诊
   * @param form
   * @returns {Promise<void>}
   */
  async assIssue(form) {
    const {code} = await this.$http('smarthos.referral.order.ass.issue', form);
    return code === '0';
  }

  /**
   * 医医转诊
   * @param form
   * @returns {Promise<void>}
   */
  async docIssue(form) {
    const {code} = await this.$http('smarthos.referral.order.doc.issue', form);
    return code === '0';
  }

  /**
   * 发起方转诊列表
   * @param referralType
   * @param referralStatusList
   * @param patName
   * @param startTime
   * @param endTime
   * @param pageSize
   * @param pageNum
   * @returns {Promise<{page, list: Array}>}
   */
  async initList({referralType, referralStatusList, patName = undefined, startTime = undefined, endTime = undefined, pageSize = 10, pageNum = 1,hopeHosId = undefined}) {
    const {code, page = {}, list = []} = await this.$http('smarthos.referral.order.init.list', {
      referralType,
      referralStatusList,
      patName,
      startTime,
      endTime,
      pageNum,
      pageSize,
      hopeHosId
    });
    return code === '0' ? {list: this.handlerListData(list), page} : {list, page};
  }

  /**
   * 接收方转诊列表
   * @param referralType
   * @param referralStatusList
   * @param patName
   * @param startTime
   * @param endTime
   * @param pageSize
   * @param pageNum
   * @returns {Promise<{page, list: Array}>}
   */
  async acceptList({referralType, referralStatusList, patName = undefined, startTime = undefined, endTime = undefined, pageSize = 10, pageNum = 1,hopeHosId = undefined}) {
    const {code, page = {}, list = []} = await this.$http('smarthos.referral.order.accept.list', {
      referralType,
      referralStatusList,
      patName,
      startTime,
      endTime,
      pageNum,
      pageSize,
      hopeHosId
    });
    return code === '0' ? {list: this.handlerListData(list), page} : {list, page};
  }

  /**
   * 全部列表
   * @param aspectUser
   * @param referralType
   * @param referralStatusList
   * @param patName
   * @param startTime
   * @param endTime
   * @param pageSize
   * @param pageNum
   * @returns {Promise<*>}
   */
  async list({aspectUser, referralType, referralStatusList, patName = undefined, startTime = undefined, endTime = undefined, pageSize = 10, pageNum = 1}) {
    const {code, page = {}, list = []} = await this.$http('smarthos.referral.order.list', {
      aspectUser,
      referralType,
      referralStatusList,
      patName,
      startTime,
      endTime,
      pageSize,
      pageNum
    });
    return code === '0' ? {list: this.handlerListData(list), page} : {list, page};
  }


  /**
   * 转诊详情
   * @param id
   * @returns {Promise<{}>}
   */
  async detail(id) {
    const {code, obj = {}} = await this.$http('smarthos.referral.order.details', {id});
    return code === '0' ? obj : {};
  }

  /**
   * 拒绝转诊
   * @param id
   * @param refuseReason
   * @returns {Promise<{}>}
   */
  async refused({id, refuseReason}) {
    const {code} = await this.$http('smarthos.referral.order.refused', {id, refuseReason});
    return code === '0';
  }

  /**
   * 取消
   * @param id
   * @param refuseReason
   * @returns {Promise<{}>}
   */
  async cancel({id, refuseReason}) {
    const {code} = await this.$http('smarthos.referral.order.cancel', {id, refuseReason});
    return code === '0';
  }


  /**
   * 要求补充资料
   * @param id
   * @param perfectReason
   * @returns {Promise<void>}
   */
  async askPerfect({id, perfectReason}) {
    const {code} = await this.$http('smarthos.referral.order.ask.perfect', {
      id,
      perfectReason
    });
    return code === '0';
  }

  /**
   * 补充资料
   * @param id
   * @param attaIdList
   * @param tentativeDiagnosis
   * @param illnessDescription
   * @returns {Promise<void>}
   */
  async perfect({id, attaIdList, tentativeDiagnosis, illnessDescription}) {
    const {code} = await this.$http('smarthos.referral.order.perfect', {
      id,
      tentativeDiagnosis,
      illnessDescription,
      attaIdList
    });
    return code === '0';
  }

  /**
   * 安排转诊
   * @param id
   * @param acceptDocId
   * @param acceptTime
   * @param referralResult
   * @returns {Promise<void>}
   */
  async process({id, acceptDocId, acceptTime, referralResult,remark}) {
    const {code} = await this.$http('smarthos.referral.order.process', {
      id,
      acceptDocId,
      acceptTime,
      referralResult,
      remark
    });
    return code === '0';
  }

  /**
   * 处理列表数据
   * @param list
   * @returns {*}
   */
  handlerListData(list) {
    if (isEmpty(list)) return list;
    return list.map(r => {
      r._sex = getSexFromIdCardFilter(r.patIdcard);
      r._ctime = timeFormat(r.createTime, '%Y-%m-%d');
      r.acceptTime && (r._acceptTime = timeFormat(r.acceptTime, '%Y-%m-%d'));
      return r;
    });
  }


}

export const referralService = new ReferralService();
